<template>
    <div class="lang-dropdown-container">
        <div class="lang-dropdown-btn" :class="{ 'is-light': lightIcon }" @click.stop="toggleMenu">
            <img
                v-if="lightIcon"
                class="lang-globe-icon lang-globe-icon--light"
                :src="langGlobeLightIcon"
                width="20"
                height="20"
                alt=""
            />
            <svg
                v-else
                class="lang-globe-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="1 1 22 22"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
            >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                <path d="M2 12h20" />
            </svg>
            <!-- <span>{{ currentLang === 'zh' ? '中' : 'En' }}</span> -->
        </div>

        <div class="lang-dropdown-menu" v-show="isOpen">
            <!-- <div class="menu-header">
        LANGUAGE / 语言
      </div> -->
            <div class="menu-list">
                <button v-for="value in list" class="lang-option" :class="{ active: appStore.language === value.value }" @click="selectLang(value.value)">
                    {{value.name}}
                    <svg v-if="appStore.language === value.value" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="icon-check">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </button>
                <!-- <button class="lang-option" :class="{ active: currentLang === 'en' }" @click="selectLang('en')">
                    English
                    <svg v-if="currentLang === 'en'" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="icon-check">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </button> -->
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAppStore } from '@/store/modules/app';
import langGlobeLightIcon from '@/assets/icons/svg/lang-globe-light.svg';

defineProps({
  /** 大屏等场景使用白色描边地球图标（独立 SVG，避免 fill 覆盖成实心圆） */
  lightIcon: {
    type: Boolean,
    default: false
  }
});
const list = ref(window.LANGUAGE_LIST)
const appStore = useAppStore();
const { t, locale } = useI18n();
const currentLang = ref('zh_CN');
const isOpen = ref(false);
const handleLanguageChange = (lang) => {
  locale.value = lang;
  appStore.changeLanguage(lang);
  // 先切换 locale 再提示，保证提示文案展示为目标语言。
  ElMessage.success(t('basicComponents.languageSwitchSuccess'));
  location.reload();
};
const toggleMenu = () => {
    isOpen.value = !isOpen.value;
};

const selectLang = (lang) => {
    handleLanguageChange(lang)
    currentLang.value = lang;
    isOpen.value = false;
};

// 点击外部关闭下拉菜单
const handleClickOutside = (event) => {
    if (isOpen.value && !event.target.closest('.lang-dropdown-container')) {
        isOpen.value = false;
    }
};

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});
</script>

<style lang="scss" scoped>
.lang-dropdown-container {
    position: relative;

    .lang-dropdown-btn {
        display: flex;
        align-items: center;
        gap: 6px;
        // background-color: #1e293b;
        // border: 1px solid rgba(51, 65, 85, 0.5);
        border-radius: 8px;
        // padding: 6px 10px;
        color: rgb(146, 155, 178);
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        transition: background-color 0.2s;

        .lang-globe-icon {
            display: block;
            flex-shrink: 0;
        }

        &:hover {
            background-color: #334155;
        }

        &.is-light:hover {
            background-color: rgb(255 255 255 / 10%);
        }
    }

    .lang-dropdown-menu {
        position: absolute;
        right: -100%;
        top: 100%;
        margin-top: 12px;
        width: 152px;
        background-color: #0f1114;
        border-radius: 12px;
        // box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.5);
        border: 1px solid #1e293b;
        overflow: hidden;
        z-index: 50;

        .menu-header {
            padding: 12px 16px;
            font-size: 11px;
            font-weight: bold;
            color: #64748b;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            border-bottom: 1px solid #1e293b;
        }

        .menu-list {
            display: flex;
            flex-direction: column;
            padding: 4px 0;

            .lang-option {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 16px;
                font-size: 14px;
                color: #cbd5e1;
                background: transparent;
                border: none;
                cursor: pointer;
                text-align: left;
                transition: all 0.2s;

                &:hover {
                    background-color: rgba(255, 255, 255, 0.05);
                }

                &.active {
                    color: #3b82f6;
                    background-color: rgba(255, 255, 255, 0.05);
                    font-weight: 500;
                }

                .icon-check {
                    color: #3b82f6;
                }
            }
        }
    }
}
</style>